import React, { useState, useEffect } from 'react';
import { useRequest } from 'umi';
import styles from '../css/dynamicCSS.less';
import cx from 'classnames';
import { DynamicType } from '@/types/camp/dynamic/dynamicType';
import { MessageOutlined } from '@ant-design/icons';
import DynamicPraise from './dynamicPraise';
import { ReactComponent as RewardSvg } from '@/static/images/reward2.svg';
import { calcTimeString } from '@/utils';
import { postReplyComments } from '@/utils/requests/camp/requests_dynamic';
import CommentsList from './commentsList';
import { message, Button, Image } from 'antd';
import CommentForm from './commentForm';

interface Props {
  item: DynamicType;
  index: number;
}

interface PostCommentsType {
  replyId: string;
  content: string;
  image?: string;
  toUid?: number;
}
const DynamicReplyItem: React.FC<Props> = ({ item, index }) => {
  const [hash, setHash] = React.useState<number>(index);
  const [isOn, setIsOn] = useState<boolean>(false);
  const toggleSwitch = () => {
    setIsOn(!isOn);
  };

  // 发布评论
  const { run: postReplyCommentsRequest } = useRequest(
    (submitValue: PostCommentsType) => {
      return postReplyComments(submitValue);
    },
    {
      manual: true,
      onSuccess: (res) => {
        message.success('操作成功');
        // 刷新回复列表
        item.commentsCount = res.commentsCount;
        setTimeout(function () {
          setHash(res.id);
        }, 500);
      },
      onError: (e) => {},
    },
  );

  return (
    <div key={index} className={styles.dynamic_box}>
      <div className={styles.item}>
        <div className={styles.lf}>
          <a href={`https://bbs.fanruan.com/u/${item.createdBy}`} target="_blank">
            <img
              className={styles.face}
              src={`https://bbs.fanruan.com/uc_server/avatar.php?uid=${item.createdBy}&amp;size=small`}
            ></img>
          </a>
        </div>
        <div className={styles.rt}>
          <div className={styles.user_name}>
            <a
              href={`https://bbs.fanruan.com/u/${item.createdBy}`}
              className="col172 hover008 f16"
              target="_blank"
            >
              {item.username}
            </a>
          </div>
          <div className={'col808 f14'}>
            <span>{calcTimeString(item.createdTime)}</span>
          </div>
          <div className={styles.info_text}>{item.content}</div>

          {item.image && (
            <Image key={index} style={{ borderRadius: 8 }} height={180} src={item.image} />
          )}

          <div className={cx(styles.tool, 'flex_1')}>
            <div className="f14">
              <DynamicPraise key={item.id} data={item} type={2} />
            </div>

            <div>
              <Button
                type="link"
                onClick={() => toggleSwitch()}
                className={cx(styles.comment, 'flex_1 col808')}
              >
                <MessageOutlined />
                <span>
                  {isOn ? '取消回复' : '回复'} {item.commentsCount > 0 ? item.commentsCount : ''}
                </span>
              </Button>
            </div>

            {item.rewardCredits > 0 && (
              <div className={cx(styles.reward, 'flex_1')}>
                <RewardSvg style={{ width: 15 }} />
                <span className="colffa">奖励 {item.rewardCredits} 学分</span>
              </div>
            )}
          </div>

          {isOn && (
            <div>
              <CommentForm
                key={item.id}
                onSubmit={(values) => {
                  const submitValue: PostCommentsType = {
                    replyId: item.id,
                    content: values.content,
                    image: values.imageUrl,
                  };
                  submitValue && postReplyCommentsRequest(submitValue);
                }}
              />
            </div>
          )}

          {item.commentsCount > 0 && (
            <div className={styles.comments_list_box}>
              <CommentsList
                key={hash}
                replyId={item.id}
                printIndex={index}
                postReplyCommentsRequest={postReplyCommentsRequest}
                isReplyOn={isOn}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default DynamicReplyItem;
